import { PagedResult } from './../../../model/common/paged-result';
import { Param } from './../../../model/common/param';
import { Component, EventEmitter, ViewChild } from '@angular/core';
import { GenericManage, GenericManageViewMode } from '../../generic/generic.manage';
import { DimensionDetailComponent as DimensionDetailUI } from './dimension.detail';
import { AssetCategoryHttpService } from '../../../services/http/assets/asset-category.http.service';
import { DimensionHttpService } from '../../../services/http/administration/dimension.http.service';
import { DimensionDetailHttpService } from '../../../services/http/administration/dimension-detail.http.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Dimension } from '../../../model/api/administration/dimension';
import { DimensionListComponent } from './dimension.list';
import { AssetCategoryListComponent } from '../asset-categories/asset-category.list';
import { AssetCategory } from '../../../model/api/assets/asset-category';
import { AppUtils } from '../../../common/app.utils';
import { DimensionDetail } from '../../../model/api/administration/dimension-detail';

@Component({
    selector: 'app-dimension-manage',
    templateUrl: 'dimension.manage.html',
    providers: [ AssetCategoryHttpService, DimensionHttpService, DimensionDetailHttpService ]
})
export class DimensionManageComponent extends GenericManage<Dimension, number> {

    @ViewChild('dimensionDetailModal') dimensionDetailModal: ModalDirective;
    @ViewChild('dimensionList') dimensionList: DimensionListComponent;
    @ViewChild('dimensionDetail') dimensionDetail: DimensionDetailUI;
    @ViewChild('assetCategoryListModal') assetCategoryListModal: ModalDirective;
    @ViewChild('assetCategoryList') assetCategoryList: AssetCategoryListComponent;

    public filter: string = '';
    public selectedAssetCategory: AssetCategory = null;
    isCollapsed: boolean = true;
    constructor(
        public assetCategoryHttpService: AssetCategoryHttpService,
        public dimensionHttpService: DimensionHttpService,
        public dimensionDetailHttpService: DimensionDetailHttpService,
        ) {

        super();
    }

    public addNewItem() {
        super.addNewItem();

        this.dimensionDetail.assetCategory = null;
    }

    public editItem() {
        super.editItem();

        let dimension: DimensionDetail = this.selectedItem as DimensionDetail;

        this.dimensionDetail.assetCategory = null;

        if (dimension != null && dimension.assetCategory != null) {
            this.assetCategoryHttpService
                .getById(dimension.assetCategory.id)
                .subscribe((assetCategory: AssetCategory) => {
                    this.dimensionDetail.assetCategory = assetCategory;
                });
        }
    }

    public detailInitialize() {
        super.detailInitialize();
        this.dimensionDetailModal.show();
    }

    public detailTerminate() {
        super.detailTerminate();
        this.dimensionDetailModal.hide();
    }

    public onDimensionDetailAssetCategoryNeeded() {
        this.dimensionDetailModal.hide();
        this.selectAssetCategory();
    }

    public onAssetCategoryListCancel() {
        this.assetCategoryListModal.hide();
        if (this.viewMode === GenericManageViewMode.ItemDetail) {
            this.dimensionDetailModal.show();
        }
    }

    public refresh() {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('filter', this.filter));
        params.push(new Param('assetCategoryIds', AppUtils.getIdsList<AssetCategory, number>([ this.selectedAssetCategory ])));

        this.dimensionList.refresh(params);
    }

    public selectAssetCategory() {
        this.assetCategoryListModal.show();
        this.assetCategoryList.refresh(null);
    }

    public setSelectedAssetCategory() {
        switch(this.viewMode) {
            case GenericManageViewMode.ItemList:
                this.selectedAssetCategory = this.assetCategoryList.selectedItem;
                this.assetCategoryListModal.hide();
                this.refresh();
                break;
            case GenericManageViewMode.ItemDetail:
                this.dimensionDetail.assetCategory = this.assetCategoryList.selectedItem;
                this.assetCategoryListModal.hide();
                this.dimensionDetailModal.show();
                break;
        }
    }


    public unselectAssetCategory() {
        this.selectedAssetCategory = null;
        this.refresh();
    }

    public exportToExcel() {

         let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.dimensionDetailHttpService.get(1, 1000000, 'length', 'asc', params, null).subscribe(
            (data: PagedResult<Dimension>) => {

                let options = {
                    sheetid: 'Dimensions',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // let res = alasql(`SELECT id as [Id],
                //                     length as [Lungimr],
                //                     width as [Latime],
                //                     height as [Inaltime]
                //                     INTO XLSX('Dimensions.xlsx',?) FROM ?`,[ options, data.items ]);

            });
    }

    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }
}
